<template>
  <div class="activity">
    <div v-if="!isPc" class="activity-wap-title" @click="showTop = !showTop"><span>{{ data[activeBig]["lableDesc" + En] }}</span><img src="https://static.worldaic.com.cn/2024/web/static/images/bottom-icon.png" alt=""></div>
    <div class="activity-top" v-if="isPc || (!isPc && showTop)" @click="showTop = !showTop">
      <div class="activity-top-content">
        <div class="item1">
          <span v-for="(item, index) in data" :class="activeBig === index ? 'active' : ''" @mouseenter="activeBig = index" @click="routerPoint" :key="index">{{ item["lableDesc" + En] }}</span>
        </div>
        <div class="line"></div>
        <div class="item2" v-if="data[activeBig] && data[activeBig].sonReqOne">
          <span v-for="(item, index) in data[activeBig].sonReqOne" :key="index" @click="routerPoint('small', index)">
            {{ item['activityTitle' + En] }}
          </span>
        </div>
      </div>
    </div>
    <div class="container">
      <template>
        <div v-for="(item, index) in data" :key="'a' + index">
          <div :id="'q' + index" style="position: relative; top: -2.5rem"></div>
          <div class="pub-title title1" style="text-align: left"><span>{{ item["lableDesc" + En] }}</span></div>
          <div class="activity-item">
            <div class="activity-img">
              <img class="img1" :src="item['activityCoverPc']" />
              <ul class="text">
                <li>
                  <img src="https://static.worldaic.com.cn/2024/web/static/images/clock.png" alt="">
                  <span>{{ getTime(`${item.startTime}++${item.endTime}`) }}</span>
                </li>
                <li>
                  <img src="https://static.worldaic.com.cn/2024/web/static/images/addr.png" alt="">
                  <span>{{ item['address' + En] }}</span>
                </li>
              </ul>
            </div>
            <div
              :class="['activity-cont', 'activity-cont' + item.activityType]"
              v-if="
                item.sonReqOne &&
                item.sonReqOne.length &&
                item.sonReqTwo &&
                item.sonReqTwo.length
              "
            >
              <ul class="develop-tab">
                <li
                  v-for="(ite, ind) in item.sonReqOne"
                  :class="item.oneIndex == ind ? 'active' : ''"
                  :key="'c' + ind"
                  @click="checkIndex(index, ind, 'oneIndex')"
                >
                  {{ ite["activityTitle" + En] }}
                </li>
              </ul>
              <ul
                class="tab"
                v-if="
                  item.sonReqTwo &&
                  item.sonReqTwo.filter(
                    (x) =>
                      x.activitySonUuid === item.sonReqOne[item.oneIndex].uuid
                  )
                "
              >
                <li
                  v-for="(ite, ind) in item.sonReqTwo.filter(
                    (x) =>
                      x.activitySonUuid === item.sonReqOne[item.oneIndex].uuid
                  )"
                  :class="item.twoIndex == ind ? 'active' : ''"
                  :key="'b' + ind"
                  @click="checkIndex(index, ind, 'twoIndex')"
                >
                  {{ ite["activityTitle" + En] }}
                </li>
              </ul>
              
              <div class="scroll">
                <p
                  v-html="item.sonReqTwo[item.twoIndex]['activityDesc' + En]"
                ></p>
              </div>
            </div>
            <div
              :class="['activity-cont', 'activity-cont' + item.activityType]"
              v-else
            >
              <!-- <ul
                class="tab"
                v-if="item.sonReqOne && item.sonReqOne.length > 1"
              >
                <li
                  v-for="(ite, ind) in item.sonReqOne"
                  :class="item.oneIndex == ind ? 'active' : ''"
                  :key="ind"
                  @click="checkIndex(index, ind, 'oneIndex')"
                >
                  {{ ite["activityTitle" + En] }}
                </li>
              </ul> -->
              <waic-tabs v-if="item.sonReqOne && item.sonReqOne.length > 0" jc="left" width="auto" :ref="'a' + index * 1000" :id="index * 1000" padding="0 0.55rem" :data="item.sonReqOne.map(x => x['activityTitle' + En])" class="tabs" @update:active="v => checkIndex(index, v, 'oneIndex')"></waic-tabs>
              <div class="scroll">
                <p
                  v-html="item.sonReqOne[item.oneIndex]['activityDesc' + En]"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- <meetDialog
      :showMeetModal.sync="showMeetModal"
      :uuid.sync="uuid"
      @closeMeetModal="closeMeetModal"
    ></meetDialog> -->
  </div>
</template>
<script>
import protal from "@/api/protal";
// import meetDialog from "@/components/meetDialog.vue";
export default {
  components: {
    // meetDialog,
  },
  data() {
    return {
      showTop: false,
      activeBig: 0,
      activeSmall: -1,
      isFirst: true,
      tabs: ["关于SAIL奖", "2020 SAIL奖", "2019 SAIL奖", "2018 SAIL奖"],
      tabs2: ["世界", "黑客马拉松"],
      tabs3: ["详情", "赛程", "评委", "参赛队伍"],
      dates: ["07/09", "07/10"],
      dateIndex: 0,
      tabIndex: 0,
      tabIndex2: 0,
      tabIndex3: 0,
      activityType: [],
      data: [],
      activityList: [],
      forumDateList: [],
      dateList: [],
      learnDetail: "",
      seriesMeet: "",
      meetDetail: {},
      showMeetModal: false,
      uuid:"",
      active: 0
    };
  },
  created() {
    this.pageView('gw_saishipage')
    this.init();
  },
  activated() {
    this.init();
  },
  computed: {
    getTime() {
      return str => {
        if (!str) return ''
        str = str.replace(/\-/g, '/')
        let arr = str.split('++')
        arr = arr.map(x => {
          if (x.slice(0, 1) == '0') {
            x = x.slice(1)
          }
          x = x.split(' ')
          return x
        })
        if (arr[1][0] === arr[0][0]) {
          arr[1].shift()
        }
        arr = arr.map(x => {
          x = x.join(' ')
          return x
        })
        return arr.join('-')
      }
    }
  },
  methods: {
    routerPoint(type, index) {
      if (type === 'small') {
        this.active = index
        const str = 'a' + this.activeBig * 1000
        this.$refs[str][0].fn(index)
        this.$refs[str][0].scx()
        this.$jsAPI('track','competeSecNavigation',
            {
              'firstNavigation_var': this.data[this.activeBig].lableDesc,
              'position_var': `${ this.activeBig + 1 }-${ index + 1 }`,
              'secondNavigation_var': this.data[this.activeBig].sonReqOne[index].activityTitle
            }
        );
        gio('track','competeSecNavigation',
            {
              'firstNavigation_var': this.data[this.activeBig].lableDesc,
              'position_var': `${ this.activeBig + 1 }-${ index + 1 }`,
              'secondNavigation_var': this.data[this.activeBig].sonReqOne[index].activityTitle
            }
        );
      } else {
        this.$jsAPI('track','competeFirstNavigation',
            {
              'firstNavigation_var': this.data[this.activeBig].lableDesc,
            }
        );
        gio('track','competeFirstNavigation',
            {
              'firstNavigation_var': this.data[this.activeBig].lableDesc,
            }
        );
      }
      this.$router.push(`activity#q${this.activeBig}`)
      this.scrollTo();
    },
    async init() {
      await protal.getZdType("activity_type").then((res) => {
        if (res && res.data && res.data.length) {
          this.activityType = res.data;
        }
      });
      await protal.queryCharacteristicActivityList().then((res) => {
        if (res && res.data && res.data.length) {
          this.activityList = res.data;
          this.data.length = this.activityList.length;
          console.log(this.activityList);
        }
      });
      const data = JSON.parse(JSON.stringify(this.data));
      this.activityList.forEach((x, i) => {
        const item =
          this.activityType.filter((y) => y.uuid === x.activityType)[0] || {};
        protal.queryCharacteristicActivity(x.uuid).then((res) => {
          if (res && res.data) {
            res.data.lableDesc = item.lableDesc;
            res.data.lableDescEn = item.lableDescEn;
            res.data.oneIndex = 0;
            res.data.twoIndex = 0;
            
            data.splice(i, 1, res.data);
            if (!data.filter(x => !x).length) {
              this.data = data
            }
          }
        });
      });
    },
    async getData() {
      await protal.getZdCode("forum_time").then((res) => {
        if (res && res.data && res.data.length) {
          this.dateList = res.data;
          this.date = this.dateList[0].uuid;
        }
      });
      let params = {
        officialForumTypes: [38, 39, 160, 40, 41, 42],
        isOfficialQuery: 1,
        pageNum: 1,
        pageSize: 999,
      };
      protal.queryForumList(params).then((res) => {
        if (res && res.data && res.data.length) {
          this.forumList = res.data;
          // this.forumList.sort(function (a, b) {
          //   return b.startTime < a.startTime ? 1 : -1;
          // });
          // this.forumList.sort(function (a, b) {
          //   return b.endTime < a.endTime ? 1 : -1;
          // });
          this.dateClick(0, this.dateList[0].uuid);
        }
      });
    },
    checkIndex(index, ind, type) {
      const data = JSON.parse(JSON.stringify(this.data));
      data[index][type] = ind;
      this.data = data;
    },
    tabClick(index) {
      this.tabIndex = index;
    },
    tabClick2(index) {
      this.tabIndex2 = index;
    },
    tabClick3(index) {
      this.tabIndex3 = index;
    },
    dateClick(index, data) {
      this.dateIndex = index;
      this.forumDateList = this.forumList.filter((x) => x.forumTime == data);
      console.log(this.forumList);
    },
    speakerClick(index) {
      this.speakerIndex = index;
    },
    learnMore(uuid) {
      this.showMeetModal = true;
      // if (data.forumOrgUnit) {
      //   data.forumOrgUnit = data.forumOrgStructureReqs
      //     .map((x) => {
      //       return x.name;
      //     })
      //     .join("、");
      //   data.forumOrgUnitEn = data.forumOrgStructureReqs
      //     .map((x) => {
      //       return x.nameEn;
      //     })
      //     .filter((item) => item)
      //     .join("、");
      // }
      this.uuid = uuid;
      var body = document.getElementsByTagName('body')[0];
      body.style.overflow="hidden"
    },
    closeMeetModal() {
      this.showMeetModal = false;
      var body = document.getElementsByTagName('body')[0];
      body.style.overflow="scroll"
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .activity {
    padding: 2.85rem 2.1rem 1.65rem;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/dahui-bg.jpg);
    background-size: 100% auto;
    
    .activity-top {
      position: fixed;
      left: 0;
      top: .96rem;
      width: 100%;
      height: 1.2rem;
      background: linear-gradient(125deg, RGBA(186, 212, 225, 1) 0%, RGBA(218, 214, 226, 1) 100%);
      z-index: 10;

      .activity-top-content {
        width: 15rem;
        margin: 0 auto;

        .item1 {
          height: .64rem;
          display: flex;
          align-items: center;

          span {
            padding: 0 .29rem;
            margin-right: .15rem;
            height: .4rem;
            border-radius: .2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            color: #0A0A0A;
            font-family: sybold;
            font-size: .2rem;

            &.active {
              background: linear-gradient(126deg, RGBA(63, 139, 243, 1) 0%, RGBA(116, 84, 236, 1) 100%);
              color: #fff;
            }
          }
        }

        .line {
          width: 100%;
          height: 1px;
          background: linear-gradient(3deg, #2F9AF4 49%, rgba(195, 4, 226, 0.5) 100%, rgba(195, 4, 226, 0.5) 0%);
          opacity: 0.24;
        }

        .item2 {
          height: .55rem;
          display: flex;
          align-items: center;

          span {
            margin-right: .57rem;
            font-size: .2rem;
            color: #656565;
            line-height: 1.5;
            font-family: sybold;
            cursor: pointer;
            white-space: nowrap;

            &:hover {
              background: linear-gradient(126deg, #2F9AF4 0%, #C304E2 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }
      }
    }

    .activity-item {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      margin: .11rem 0 1.45rem;

      .activity-img {
        background: #F6F7F7;
        border-radius: .16rem;
        margin-top: .44rem;
        height: 4.84rem;
        width: 2.8rem;

        .text {
          padding: 0.04rem .16rem .3rem;
          width: 100%;

          li {
            font-size: .22rem;
            color: #595757;
            display: flex;
            align-items: center;
            margin-top: .12rem;
            
            span {
              flex: 1;
              white-space: nowrap;
              line-height: 1.5;
            }
          }

          img {
            width: auto;
            height: .24rem;
            margin-right: 0.04rem;
          }
        }

        .img1 {
          display: block;
          width: 2.8rem;
          height: 3.8rem;
          border-radius: .16rem;
        }
      }
      
      .txt {
        display: flex;
        align-items: center;
        margin-top: 10px;
        font-size: 15px;
        line-height: 1;
        color: rgba(32, 153, 255, 1);

        img {
          margin-right: 6px;
        }

      }

      .activity-cont {
        flex: 1;
        margin-left: .9rem;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-top: -0.1rem;

        /deep/ .tabs {
          margin-bottom: .29rem;
        }

        .tab {
          display: flex;
          padding-bottom: 40px;
          li {
            background: #ffffff;
            border: 1px solid #979797;
            color: #585858;
            white-space: nowrap;
            font-size: 12px;
            margin-right: 8px;
            min-width: 30px;
            padding: 0 16px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            cursor: pointer;
            &.active {
              background: #5238A6;
              color: #fff;
              border: none;
            }
          }
        }
        .develop-tab {
          display: flex;
          li {
            color: #202020;
            font-size: 18px;
            margin-right: 44px;
            position: relative;
            cursor: pointer;
            padding: 20px 0 10px;
            &.active {
              color: #5c00b2;
              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 5px;
                background: #5c00b2;
              }
            }
          }
        }
        .scroll {
          display: block;
          max-height: 8rem;
          overflow: auto;
          box-sizing: border-box;
          padding-right: 10px;
          .scroll-item335 {
          }
          &::-webkit-scrollbar {
            width: 6px;
            height: 100%;
            border-radius: 3px;
            background: #E9E9E9;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 3px;
            background: #C8C8C8;
          }
        }
        .activity-txt {
          display: none;
        }
        p {
          text-align: left;
          font-size: .18rem;
          line-height: .28rem;
          height: 100%;
          color: #595757;

          /deep/ img {
            max-width: 100%;
          }

          b {
            // color: #202020;
          }
        }

        /deep/ h2 {
          font-size: .26rem !important;
          margin-bottom: .32rem !important;
        }

        /deep/ .happy-scroll {
          margin-top: 34px;
          .happy-scroll-content {
            padding-right: 72px;
          }
          .happy-scroll-strip--vertical {
            right: 29px;
            // background: #f8f8f8;
          }
        }
      }
      // &:nth-child(3)
    }
    .meet {
      margin-top: 81px;
    }
    .meeting {
      margin-top: 48px;
      .schedule-date {
        display: flex;
        li {
          width: 260px;
          height: 72px;
          line-height: 72px;
          background: #fff;
          color: #414141;
          font-size: 24px;
          margin-right: 35px;
          cursor: pointer;
          &.active {
            background: linear-gradient(126deg, #5600d3 0%, #610080 100%);
            color: #fff;
          }
        }
      }
      .schedule-content {
        .schedule-item {
          display: flex;
          align-items: center;
          text-align: left;
          height: 102px;
          background: #fff;
          padding-left: 42px;
          padding-right: 42px;
          &:nth-child(2n) {
            background: #fafafa;
          }
          .item-l {
            width: 247px;
            p {
              color: #008dff;
              font-size: 16px;
              line-height: 22px;
              &:first-child {
                img {
                  width: 12px;
                  height: 12px;
                  margin-right: 10px;
                }
              }
              &:last-child {
                margin-top: 1px;
                img {
                  width: 11px;
                  height: 13px;
                  margin-right: 10px;
                }
              }
            }
          }
          .item-c {
            flex: 1;
            margin-right: 40px;
          }
          .item-tit {
            font-size: 16px;
            color: #202020;
            line-height: 22px;
          }
          .item-txt {
            font-size: 12px;
            color: #585858;
            line-height: 17px;
            margin-top: 6px;
          }
          .item-r {
            width: 97px;
            height: 33px;
            line-height: 33px;
            text-align: center;
            background: #ffffff;
            border: 1px solid #707070;
            border-radius: 17px;
            color: #202020;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .activity {
    width: 100%;
    padding: 2.45rem 0 1.57rem;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/wap-bg.jpg);
    background-size: 100% auto;
    overflow: hidden;

    .activity-wap-title {
      position: fixed;
      left: 0;
      top: 1rem;
      width: 100%;
      height: .88rem;
      background: linear-gradient(125deg, RGBA(186, 212, 225, 1) 0%, RGBA(208, 213, 226, 1) 100%);
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-family: sybold;
        font-size: .28rem;
        letter-spacing: 1px;
        background: linear-gradient(126deg, #2F9AF4 0%, #C304E2 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      img {
        width: .22rem;
        height: .22rem;
        margin-left: .08rem;
      }
    }
    
    .activity-top {
      position: fixed;
      left: 0;
      top: 1.88rem;
      width: 100%;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
      z-index: 10;

      .activity-top-content {
        width: 100%;
        margin: 0 auto;

        .item1 {
          background: #F0F0F0;
          border-radius: 0px 0px .16rem .16rem;

          span {
            display: block;
            margin-right: .15rem;
            line-height: .76rem;
            text-align: center;
            cursor: pointer;
            color: #404040;
            font-family: sybold;
            font-size: .28em;


            &.active {
              background: linear-gradient(126deg, RGBA(63, 139, 243, 1) 0%, RGBA(116, 84, 236, 1) 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }

        .line {
          display: none;
        }

        .item2 {
          display: none;
        }
      }
    }

    .title1 {
      text-align: center !important;
    }

    .activity-item {
      width: 6.7rem;
      margin: .47rem auto .5rem;

      .activity-img {
        margin-bottom: .5rem;
        border-radius: .16rem;
        overflow: hidden;
        background: #F6F7F7;

        .img1 {
          width: 100%;
          display: block;
          border-radius: .16rem;
        }
        .text {
          height: 1.03rem;
          padding-left: .24rem;

          li {
            display: flex;
            align-items: center;
            margin-top: .22rem;
            font-size: .26rem;
            line-height: .28rem;
            color: #595757;
          }

          img {
            margin-right: .16rem;
            width: .28rem;
            height: .28rem;
          }

        }
      }
      .activity-cont {
        box-sizing: border-box;

        .tab {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          li {
            padding: 0 0.28rem;
            color: #585858;
            font-size: 0.15rem;
            margin: 0 0.12rem;
            height: 0.52rem;
            line-height: 0.48rem;
            margin-bottom: 0.3rem;
            &.active {
              background: #5238A6;
              color: #fff;
              border: none;
              line-height: 0.52rem;
            }
          }
        }
        .develop-tab {
          display: flex;
          justify-content: center;
          padding-left: 0.52rem;
          padding-top: 0.3rem;
          padding-bottom: 0.2rem;
          li {
            color: #202020;
            font-size: .3rem;
            margin-right: .44rem;
            position: relative;
            cursor: pointer;
            padding-top: 0.29rem;
            &.active {
              color: #5c00b2;
              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 0.06rem;
                background: #5c00b2;
              }
            }
          }
        }
        .scroll {
          display: block;
          padding: 0.33rem 0;
          /deep/ p {
            text-align: left;
            line-height: 0.38rem;
            height: 100%;
            font-size: 0.26rem;
            box-sizing: border-box;
            img {
              width: 100%;
              display: block;
              margin: .1rem 0;
            }
          }

          /deep/ h2 {
            font-size: .3rem;
            color: #333232;
            margin-bottom: .4rem;
          }
        }
        &.activity-cont334 {
          .tab {
            // background: #fff;
          }
        }
      }
    }
    .meet {
      margin-top: 0.61rem;
    }
    .meeting {
      margin-top: 0.82rem;
      .schedule-date {
        display: flex;
        li {
          width: 1.98rem;
          height: 0.55rem;
          line-height: 0.55rem;
          background: #fff;
          color: #414141;
          font-size: 0.18rem;
          margin-right: 0.26rem;
          &.active {
            background: linear-gradient(126deg, #5600d3 0%, #610080 100%);
            color: #fff;
          }
        }
      }
      .schedule-content {
        padding: 0.13rem 0.51rem 0.23rem 0.51rem;
        background: #fff;
        .schedule-item {
          text-align: left;
          border-bottom: 1px solid #707070;
          padding-top: 0.39rem;
          padding-bottom: 0.3rem;
          &:last-child {
            border: none;
          }
          .item-l {
            p {
              color: #008dff;
              font-size: 0.23rem;
              &:first-child {
                img {
                  width: 0.16rem;
                  height: 0.16rem;
                  margin-right: 0.1rem;
                }
              }
              &:last-child {
                margin-top: 1px;
                img {
                  width: 0.14rem;
                  height: 0.18rem;
                  margin-right: 0.1rem;
                }
              }
            }
          }
          .item-c {
            flex: 1;
          }
          .item-tit {
            font-size: 0.26rem;
            color: #202020;
            line-height: 22px;
            margin-top: 0.25rem;
            font-weight: bold;
          }
          .item-txt {
            font-size: 0.22rem;
            color: #585858;
            line-height: 0.3rem;
            margin-top: 0.04rem;
          }
          .item-r {
            width: 1.6rem;
            height: 0.5rem;
            line-height: 0.5rem;
            text-align: center;
            background: #ffffff;
            border: 1px solid #707070;
            border-radius: 17px;
            color: #202020;
            font-size: 0.18rem;
            margin-top: 0.2rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/index.vue